/**
 * ConversionRate function
 * @param {number} numerator - numerator
 * @param {number} denominator - denominator
 */
export default function conversionRate(numerator, denominator) {
  return denominator ? Number(((numerator / denominator) * 100).toFixed(2)) : 0;
}
